import { he } from 'src/locales';

export const CURRENT_LOCALE = 'he';
export const IS_HEBREW = true;
export const LOCALES = he;
